import { BTX_REDPLUS } from '@vfde-sails/constants';
import {
    URL_PARAM_BTYPE,
    URL_PARAM_GOTO,
    BTX_VALID_VALUES,
} from '../constant';
import { BtxType } from '../interfaces/main.interface';

/**
 * get the currentBtx value from url param
 * in case it does not find anything we are going with the default redplus type
 */
export const getCurrentBtx = (): BtxType => {
    const params = new URLSearchParams(window.location.search);
    const value = params.get(URL_PARAM_BTYPE);

    if (BTX_VALID_VALUES.includes(value as BtxType)) {
        return value as BtxType;
    }

    return BTX_REDPLUS;
};

/**
 * get the goto value from url param
 */
export const getGoToUrl = (): string | null => {
    const params = new URLSearchParams(window.location.search);

    return params.get(URL_PARAM_GOTO);
};
